<template>
  <div>
    <base-dialog :show="!!error.description" title="An error occurred" @close="handleError">
      <p>{{ error.description }}</p>
    </base-dialog>
    <base-card>
      <base-card v-if="phase === PHASE_WILDCARD">
        <h2>Regular Season Standings</h2>
        <ul style="list-style: none">
          <li v-for="conf in playoffTeams" :key="conf" style="padding: 15px">
            {{ conf[0].conference }} Playoff Teams
            <div class="team-seed" style="margin-bottom: 5px">
              <div class="team-seed--box header seed">Seed</div>
              <div class="team-seed--box header team">Team</div>
              <div class="team-seed--box header wl">W/L</div>
            </div>
            <div
              v-for="(team, seed) in conf"
              :key="team.name"
              class="team-seed"
            >
              <div class="team-seed--box seed">
                {{ seed + 1 }}
              </div>
              <div class="team-seed--box team">
                {{ team.name }}
              </div>
              <div class="team-seed--box wl">
                {{ team.wins }} /
                {{ currentSeason.seasonGamesPerTeam - team.wins }}
              </div>
            </div>
          </li>
        </ul>
      </base-card>
      <h2>
        Picks for "{{ nickName }}"
        <div class="picks--complete">
          {{ "(Picks " + (picksComplete ? "Complete)" : "Incomplete)") }}
        </div>
      </h2>
      <div v-if="phase === PHASE_REGULARSEASON">
        <label for="nickname">Nickname: </label>
        <input
          type="text"
          placeholder="Nickname"
          v-model.trim="nickName"
          class="nickname"
          ref="nickname"
        />
      </div>
      <div v-if="currentSchedule.length > 0">
        <div v-if="phase === PHASE_REGULARSEASON" class="div--weeks">
          <h3>{{ picksPhases[PHASE_REGULARSEASON] }}</h3>
          <input
            type="text"
            placeholder="Filter by team"
            v-model="teamFilter"
            class="filter--team"
          />
          <div style="clear: both"></div>
          <ul class="list--weeks">
            <li v-for="week in seasonWeeks" :key="week">
              <base-card>
                <h3>Week {{ week }}</h3>
                <ol>
                  <li v-for="game in filteredGames(week)" :key="game.gameId">
                    <div style="justify-content: center">
                      <div class="div--visitor">
                        <input
                          v-if="gamePicks.length >= game.gameId"
                          type="radio"
                          :id="game.gameId + '_Visitor'"
                          :name="game.gameId"
                          :value="currentSchedule[game.gameId - 1].visitor"
                          v-model="gamePicks[game.gameId - 1].winner"
                        />
                        <label
                          class="label--visitor"
                          :for="game.gameId + '_Visitor'"
                          >{{ currentSchedule[game.gameId - 1].visitor }}</label
                        >
                      </div>
                      <div class="div--home">
                        <input
                          v-if="gamePicks.length >= game.gameId"
                          type="radio"
                          :id="game.gameId + '_Home'"
                          :name="game.gameId"
                          :value="currentSchedule[game.gameId - 1].home"
                          v-model="gamePicks[game.gameId - 1].winner"
                        />
                        <label
                          class="label--home"
                          :for="game.gameId + '_Home'"
                          >{{ currentSchedule[game.gameId - 1].home }}</label
                        >
                      </div>
                    </div>
                  </li>
                </ol>
              </base-card>
            </li>
          </ul>
          <div class="buttons--list">
            <base-button class="button--first">Prev</base-button>
            <base-button
              @click="saveWeek(PHASE_REGULARSEASON)"
              class="button--next"
              >{{ picksPhases[PHASE_WILDCARD] }}</base-button
            >
          </div>
          <div style="clear: both"></div>
        </div>
        <div v-else-if="phase === PHASE_WILDCARD" class="div--weeks">
          <div class="list--weeks">
            <base-card>
              <h3>{{ picksPhases[PHASE_WILDCARD] }}</h3>
              <ol>
                <li v-for="game in wcGames" :key="game.gameId">
                  <div class="div--visitor">
                    <input
                      v-if="gamePicks.length >= game.gameId"
                      type="radio"
                      :id="game.gameId + '_Visitor'"
                      :name="game.gameId"
                      :value="game.visitor"
                      v-model="gamePicks[game.gameId - 1].winner"
                    />
                    <label
                      class="label--visitor"
                      :for="game.gameId + '_Visitor'"
                      >{{ game.visitor }}</label
                    >
                  </div>
                  <div class="div--home">
                    <input
                      v-if="gamePicks.length >= game.gameId"
                      type="radio"
                      :id="game.gameId + '_Home'"
                      :name="game.gameId"
                      :value="game.home"
                      v-model="gamePicks[game.gameId - 1].winner"
                    />
                    <label class="label--home" :for="game.gameId + '_Home'">{{
                      game.home
                    }}</label>
                  </div>
                </li>
              </ol>
            </base-card>
          </div>
          <div class="buttons--list">
            <base-button
              @click="lastWeek(PHASE_REGULARSEASON)"
              class="button--prev"
              >Prev</base-button
            >
            <base-button
              @click="saveWeek(PHASE_WILDCARD)"
              class="button--next"
              >{{ picksPhases[PHASE_DIVISION] }}</base-button
            >
          </div>
          <div style="clear: both"></div>
        </div>
        <div v-else-if="phase === PHASE_DIVISION" class="div--weeks">
          <div class="list--weeks">
            <h3>{{ picksPhases[PHASE_DIVISION] }}</h3>
            <base-card>
              <ol>
                <li v-for="game in divGames" :key="game.gameId">
                  <div class="div--visitor">
                    <input
                      v-if="gamePicks.length >= game.gameId"
                      type="radio"
                      :id="game.gameId + '_Visitor'"
                      :name="game.gameId"
                      :value="game.visitor"
                      v-model="gamePicks[game.gameId - 1].winner"
                    />
                    <label
                      class="label--visitor"
                      :for="game.gameId + '_Visitor'"
                      >{{ game.visitor }}</label
                    >
                  </div>
                  <div class="div--home">
                    <input
                      v-if="gamePicks.length >= game.gameId"
                      type="radio"
                      :id="game.gameId + '_Home'"
                      :name="game.gameId"
                      :value="game.home"
                      v-model="gamePicks[game.gameId - 1].winner"
                    />
                    <label class="label--home" :for="game.gameId + '_Home'">{{
                      game.home
                    }}</label>
                  </div>
                </li>
              </ol>
            </base-card>
          </div>
          <div class="buttons--list">
            <base-button @click="lastWeek(PHASE_WILDCARD)" class="button--prev"
              >Prev</base-button
            >
            <base-button
              @click="saveWeek(PHASE_DIVISION)"
              class="button--next"
              >{{ picksPhases[PHASE_CONFERENCE] }}</base-button
            >
          </div>
          <div style="clear: both"></div>
        </div>
        <div v-else-if="phase === PHASE_CONFERENCE" class="div--weeks">
          <div class="list--weeks">
            <h3>{{ picksPhases[PHASE_CONFERENCE] }}</h3>
            <base-card>
              <ol>
                <li v-for="game in confGames" :key="game.gameId">
                  <div class="div--visitor">
                    <input
                      v-if="gamePicks.length >= game.gameId"
                      type="radio"
                      :id="game.gameId + '_Visitor'"
                      :name="game.gameId"
                      :value="game.visitor"
                      v-model="gamePicks[game.gameId - 1].winner"
                    />
                    <label
                      class="label--visitor"
                      :for="game.gameId + '_Visitor'"
                      >{{ game.visitor }}</label
                    >
                  </div>
                  <div class="div--home">
                    <input
                      v-if="gamePicks.length >= game.gameId"
                      type="radio"
                      :id="game.gameId + '_Home'"
                      :name="game.gameId"
                      :value="game.home"
                      v-model="gamePicks[game.gameId - 1].winner"
                    />
                    <label class="label--home" :for="game.gameId + '_Home'">{{
                      game.home
                    }}</label>
                  </div>
                </li>
              </ol>
            </base-card>
          </div>
          <div class="buttons--list">
            <base-button @click="lastWeek(PHASE_DIVISION)" class="button--prev"
              >Prev</base-button
            >
            <base-button
              @click="saveWeek(PHASE_CONFERENCE)"
              class="button--next"
              >{{ picksPhases[PHASE_SUPERBOWL] }}</base-button>
          </div>
          <div style="clear: both"></div>
        </div>
        <div v-else-if="phase === PHASE_SUPERBOWL" class="div--weeks">
          <div class="list--weeks">
            <h3>{{ picksPhases[PHASE_SUPERBOWL] }}</h3>
            <base-card>
              <ol>
                <li v-for="game in sbGame" :key="game.gameId">
                  <div class="div--visitor">
                    <input
                      v-if="gamePicks.length >= game.gameId"
                      type="radio"
                      :id="game.gameId + '_Visitor'"
                      :name="game.gameId"
                      :value="game.visitor"
                      v-model="gamePicks[game.gameId - 1].winner"
                    />
                    <label
                      class="label--visitor"
                      :for="game.gameId + '_Visitor'"
                      >{{ game.visitor }}</label
                    >
                  </div>
                  <div class="div--home">
                    <input
                      v-if="gamePicks.length >= game.gameId"
                      type="radio"
                      :id="game.gameId + '_Home'"
                      :name="game.gameId"
                      :value="game.home"
                      v-model="gamePicks[game.gameId - 1].winner"
                    />
                    <label class="label--home" :for="game.gameId + '_Home'">{{
                      game.home
                    }}</label>
                  </div>
                </li>
              </ol>
            </base-card>
          </div>
          <div class="buttons--list">
          <base-button @click="lastWeek(PHASE_CONFERENCE)" class="button--prev"
            >Prev</base-button
          >
          <base-button @click="saveWeek(PHASE_SUPERBOWL)" class="button--next"
            >Finalize Picks</base-button
          >
          </div>
          <div style="clear: both"></div>
        </div>
        <div v-else-if="phase === PHASE_RECAP" class="div--weeks">
          <h3>{{ picksPhases[PHASE_RECAP] }}</h3>
          <ul class="list--weeks">
            <li v-for="week in allWeeks" :key="week">
              <base-card v-if="week === +seasonWeeks + 4">
                <h3>{{ picksPhases[PHASE_SUPERBOWL] }}</h3>
                <ol>
                  <li v-for="(game, idx) in sbGame" :key="game.gameId">
                    <div
                      :class="
                        gamePicks[game.gameId - 1].winner ===
                        sbGame[idx].visitor
                          ? 'div--winner'
                          : 'div--loser'
                      "
                    >
                      <label>{{ sbGame[idx].visitor }}</label>
                    </div>
                    <div
                      :class="
                        gamePicks[game.gameId - 1].winner === sbGame[idx].home
                          ? 'div--winner'
                          : 'div--loser'
                      "
                    >
                      <label>{{ sbGame[idx].home }}</label>
                    </div>
                  </li>
                </ol>
              </base-card>
              <base-card v-else-if="week === +seasonWeeks + 3">
                <h3>{{ picksPhases[PHASE_CONFERENCE] }}</h3>
                <ol>
                  <li v-for="(game, idx) in confGames" :key="game.gameId">
                    <div
                      :class="
                        gamePicks[game.gameId - 1].winner ===
                        confGames[idx].visitor
                          ? 'div--winner'
                          : 'div--loser'
                      "
                    >
                      <label>{{ confGames[idx].visitor }}</label>
                    </div>
                    <div
                      :class="
                        gamePicks[game.gameId - 1].winner ===
                        confGames[idx].home
                          ? 'div--winner'
                          : 'div--loser'
                      "
                    >
                      <label>{{ confGames[idx].home }}</label>
                    </div>
                  </li>
                </ol>
              </base-card>
              <base-card v-else-if="week === +seasonWeeks + 2">
                <h3>{{ picksPhases[PHASE_DIVISION] }}</h3>
                <ol>
                  <li v-for="(game, idx) in divGames" :key="game.gameId">
                    <div
                      :class="
                        gamePicks[game.gameId - 1].winner ===
                        divGames[idx].visitor
                          ? 'div--winner'
                          : 'div--loser'
                      "
                    >
                      <label>{{ divGames[idx].visitor }}</label>
                    </div>
                    <div
                      :class="
                        gamePicks[game.gameId - 1].winner === divGames[idx].home
                          ? 'div--winner'
                          : 'div--loser'
                      "
                    >
                      <label>{{ divGames[idx].home }}</label>
                    </div>
                  </li>
                </ol>
              </base-card>
              <base-card v-else-if="week === +seasonWeeks + 1">
                <h3>{{ picksPhases[PHASE_WILDCARD] }}</h3>
                <ol>
                  <li v-for="(game, idx) in wcGames" :key="game.gameId">
                    <div
                      :class="
                        gamePicks[game.gameId - 1].winner ===
                        wcGames[idx].visitor
                          ? 'div--winner'
                          : 'div--loser'
                      "
                    >
                      <label>{{ wcGames[idx].visitor }}</label>
                    </div>
                    <div
                      :class="
                        gamePicks[game.gameId - 1].winner === wcGames[idx].home
                          ? 'div--winner'
                          : 'div--loser'
                      "
                    >
                      <label>{{ wcGames[idx].home }}</label>
                    </div>
                  </li>
                </ol>
              </base-card>
              <base-card v-else>
                <h3>Week {{ week }}</h3>
                <ol>
                  <li v-for="game in weekGames(week)" :key="game.gameId">
                    <div
                      :class="
                        gamePicks[game.gameId - 1].winner ===
                        currentSchedule[game.gameId - 1].visitor
                          ? 'div--winner'
                          : 'div--loser'
                      "
                    >
                      <label>{{
                        currentSchedule[game.gameId - 1].visitor
                      }}</label>
                    </div>
                    <div
                      :class="
                        gamePicks[game.gameId - 1].winner ===
                        currentSchedule[game.gameId - 1].home
                          ? 'div--winner'
                          : 'div--loser'
                      "
                    >
                      <label class="label--home">{{
                        currentSchedule[game.gameId - 1].home
                      }}</label>
                    </div>
                  </li>
                </ol>
              </base-card>
            </li>
          </ul>
          <div class="buttons--list">
            <base-button @click="goHome" class="button--prev">Home</base-button>
            <base-button v-if="preTournament" @click="saveWeek(PHASE_RECAP)" class="button--next"
              >Edit Picks</base-button
            >
          </div>
          <div style="clear: both"></div>
        </div>
        <div v-else>
          <h3>Unknown Week. Phase = {{ phase }}</h3>
        </div>
      </div>
      <p v-else>No Active Season.</p>
    </base-card>
  </div>
</template>

<script>
import ShowSnackbar from "../../mixins/ShowSnackbar.js";

export default {
  mixins: [ShowSnackbar],
  computed: {
    currentPicks() {
      return this.$store.getters["picks/currentPicks"];
    },
    gamePicks() {
      return this.updatedPicks.picksList;
    },
    nickName: {
      // getter
      get() {
        return this.updatedPicks.nickName;
      },
      set(newName) {
        this.updatedPicks.nickName = newName;
      }
    },
    picksComplete() {
      return this.updatedPicks.picksComplete;
    },
    userId() {
      return this.updatedPicks.userId;
    },
    currentSchedule() {
      return this.$store.getters["schedules/currentSchedule"];
    },
    currentSeason() {
      return this.$store.getters["seasons/currentSeason"];
    },
    currentTeamsList() {
      return this.$store.getters["teams/currentTeamsList"];
    },
    seasonId() {
      return this.currentSeason.seasonId;
    },
    seasonWeeks() {
      return this.currentSeason.regularSeasonWeeks;
    },
    allWeeks() {
      // add four for the playoff weeks (assumes 4 week playoffs)
      return this.currentSeason.regularSeasonWeeks + 4;
    },
    seasonGames() {
      const theSeason = this.currentSeason;

      return (
        (theSeason.conferences.length *
          theSeason.divisions.length *
          theSeason.teamsPerDivision *
          theSeason.seasonGamesPerTeam) /
        2
      );
    },
    preTournament() {
      console.group("preTournament");
      console.info("preTournament = ", this.currentSeason.tournamentPickingOpen);
      console.groupEnd();
      return this.currentSeason.tournamentPickingOpen === true;
    },
  },
  props: ["id"],
  beforeMount() {
    console.group("UserPicks.vue beforeMount()");

    const userId = this.$store.getters.userId;
//    const userName = this.$store.getters.userName;

    // copy currentPicks to pick
    console.info("allPicksList = ");
    console.table(this.$store.getters["picks/allPicksList"]);

    console.info("currentPicks = ", this.currentPicks);
    console.info("updatedPicks = ", this.updatedPicks);
    this.updatedPicks = new Object();
    Object.assign(this.updatedPicks, this.currentPicks);
    this.updatedPicks.picksList = this.currentPicks.picksList ? this.currentPicks.picksList : [];
    console.info("this.updatedPicks = ", this.updatedPicks);

    if (
      this.updatedPicks.picksList === null ||
      this.updatedPicks.picksList.length === 0
    ) {
      // This user never had picks
      this.updatedPicks.userId = userId;
//      this.updatedPicks.nickName = userName;
      this.updatedPicks.nickName = "";

      console.info("initializing all picks to home team.");

      for (let i = 1; i <= this.currentSchedule.length; i++) {
        const pick = {
          gameId: i,
          winner: this.currentSchedule[i - 1].home,
        };

        this.updatedPicks.picksList.push(pick);
      }
    }

    console.info("this.updatedPicks.picksList = ", this.updatedPicks.picksList);

    if (this.picksComplete) {
      this.phase = this.PHASE_RECAP;

      // need to call the following to "create" all the playoff games
      this.determinePlayoffTeams();
      this.determineDivisionGames();
      this.determineConferenceGames();
      this.determineSuperBowlGame();
    } else if ( !this.preTournament ) {
        this.error.description = "Tournament is closed, please try again next year.";
        this.error.nextURL = "/";
        return;
    }

    console.groupEnd();
  },
  mounted() {
    console.group("Mounted")
    if ( this.phase === this.PHASE_REGULARSEASON ) {
      console.info("setting focus to the nickname field");
      this.focusOnField("nickname");
    }
    console.groupEnd();
  },
  data() {
    return {
      updatedPicks: null,
      picksPhases: [
        "Regular Season",
        "Wildcard Week",
        "Divisional Playoffs",
        "Conference Championships",
        "Super Bowl",
        "Season Summary",
      ],
      PHASE_REGULARSEASON: 0,
      PHASE_WILDCARD: 1,
      PHASE_DIVISION: 2,
      PHASE_CONFERENCE: 3,
      PHASE_SUPERBOWL: 4,
      PHASE_RECAP: 5,
      phase: 0,
      playoffTeams: [], // Playoff Teams (in seed order) - 7 teams @ conference
      wcGames: [],
      round2Teams: [], // Divisional Playoffs Teams (in seed order) - 4 teams @ conference
      divGames: [],
      round3Teams: [], // Conference Championships Teams (in seed order) - 2 teams @ conference
      confGames: [],
      round4Teams: [], // Super Bowl Teams (in seed order?) - 2 teams
      sbGame: [],
      teamFilter: "",
      error: {
        description: null,
        focusField: null,
        nextURL: null,
      },
    };
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    handleError() {
      this.error.description = null;
      if ( this.error.focusField !== null ) {
        this.focusOnField(this.error.focusField);
        this.error.focusField = null;
      }

      if ( this.error.nextURL ) {
        const nextURL = this.error.nextURL;
        this.error.nextURL = null;
        this.$router.push(nextURL);
      }
    },
    focusOnField(ref) {
      this.$refs[ref].focus();
    },
    weekGames(week) {
      console.group("weekGames(" + week + ")");
      console.info("week = ", week);

      const games = this.currentSchedule.filter((game) => {
        return game.weekNumber === week;
      });

      console.info("games = ", games);
      console.groupEnd();
      return games;
    },
    filteredGames(week) {
      return this.weekGames(week).filter((game) => {
        const homeTeam = game.home.toLowerCase();
        const visitorTeam = game.visitor.toLowerCase();
        const searchTerm = this.teamFilter.toLowerCase();

        return (
          homeTeam.includes(searchTerm) || visitorTeam.includes(searchTerm)
        );
      });
    },
    saveWeek(phase) {
      console.group("saveWeek(" + phase + ")");
      // save this week's info

      if (phase === this.PHASE_REGULARSEASON ) {
        console.info("REGULAR SEASON save");
        if ( this.nickName === "") {
          this.error.description = "Nickname must not be blank.";
          this.error.focusField = "nickname";
          console.info("REGULAR SEASON save: missing Nickname");
          return;
        } else {
          const otherNickNames = this.$store.getters["picks/allPicksList"].filter((user) => {
            return user.nickName === this.nickName && user.userId !== this.userId 
          });

          if ( otherNickNames.length > 0 ) {
            this.error.description = "Nickname already in use, please try another.";
            this.error.focusField = "nickname";
            console.info("REGULAR SEASON save: Duplicate Nickname");
            return;
          }
        }
      }

      if (phase === this.PHASE_SUPERBOWL) {
        // completed all games, mark picks Complete
        // (need to do this before we save)
        this.updatedPicks.picksComplete = true;
      } else if (phase !== this.PHASE_RECAP) {
        // We potentially made changes, so mark picks as Incomplete
        this.updatedPicks.picksComplete = false;
      }

      if (phase !== this.PHASE_RECAP) {
        // save the picks to DB and into currentPicks
        this.$store.dispatch("picks/savePick", this.updatedPicks);
        if ( phase === this.PHASE_SUPERBOWL ) {
          this.openSnackbar("Picks Complete!", "success");
        } else {
          this.openSnackbar("Saved picks successfully", "success");
        }
      }

      // reset filter
      this.teamFilter = "";

      switch (phase) {
        case this.PHASE_REGULARSEASON:
          // calculate SeasonWinners
          this.determinePlayoffTeams();
          console.info("after determinePlayoffTeams");
          this.phase = this.PHASE_WILDCARD;
          break;

        case this.PHASE_WILDCARD:
          // determine Divisional Playoffs games
          this.determineDivisionGames();
          this.phase = this.PHASE_DIVISION;
          break;

        case this.PHASE_DIVISION:
          // determine Conference Championships games
          this.determineConferenceGames();
          this.phase = this.PHASE_CONFERENCE;
          break;

        case this.PHASE_CONFERENCE:
          // determine Super Bowl game
          this.determineSuperBowlGame();
          this.phase = this.PHASE_SUPERBOWL;
          break;

        case this.PHASE_SUPERBOWL:
          // determine Super Bowl game
          this.phase = this.PHASE_RECAP;
          break;

        case this.PHASE_RECAP:
          // do we need to do anything here?
          this.phase = this.PHASE_REGULARSEASON;
          break;
      }
      console.info("leaving saveWeek");
      console.groupEnd();
    },
    lastWeek(phase) {
      console.group("lastWeek(" + phase + ")");
      switch (phase) {
        case this.PHASE_REGULARSEASON:
          this.phase = this.PHASE_REGULARSEASON;
          break;

        case this.PHASE_WILDCARD:
          this.phase = this.PHASE_WILDCARD;
          break;

        case this.PHASE_DIVISION:
          this.phase = this.PHASE_DIVISION;
          break;

        case this.PHASE_CONFERENCE:
          this.phase = this.PHASE_CONFERENCE;
          break;

        case this.PHASE_SUPERBOWL:
          this.phase = this.PHASE_SUPERBOWL;
          break;
      }

      console.groupEnd();
    },
    determinePlayoffTeams() {
      // calculate Regular Season Winners / Playoff Teams

      // 1. Division champ with the best record
      // 2. Division champ with the second best record
      // 3. Division champ with the third best record
      // 4. Division champ with the fourth best record
      // 5. The Wild Card team with the best record (best record after the above 4)
      // 6. The Wild Card team with the second best record (best record after above 5)
      // 7. The Wild Card team with the third best record (best record after above 6)

      // create list of teams by conference by division

      const theSeason = this.currentSeason;
      // {
      //   seasonId:
      //   year:
      //   isActive:
      //   conferences:
      //   divisions:
      //   teamsPerDivision:
      //   seasonGamesPerTeam:
      //   regularSeasonWeeks:
      //   seasonStartDate:
      //   seasonEndDate:
      //   tournamentStartDate:
      //   tournamentPickingOpen:
      // }

      // const theSchedule = this.currentSchedule;
      // {
      //   seasonId:
      //   weekNumber:
      //   gameId:
      //   home:
      //   visitor:
      //   winner:
      // }

      const theTeamsWithWins = this.createTeamsListWithWins();
      // {
      //   teamId:
      //   conference:
      //   division:
      //   name:
      // }

      // const myPicks = this.updatedPicks.picksList;
      // {
      //   winner: teamId,
      // },

      let confWinners = [];
      let confSeeds = [];

      console.group("determinePlayoffTeams");

      for (let conf = 0; conf < theSeason.conferences.length; conf++) {
        confWinners = [];

        for (let div = 0; div < theSeason.divisions.length; div++) {
          // for ( let conf = 0; conf < 1; conf++ ) {
          //   for ( let div = 0; div < 1; div++ ) {
          let divTeams = theTeamsWithWins.filter((team) => {
            return (
              team.conference === theSeason.conferences[conf] &&
              team.division === theSeason.divisions[div]
            );
          });

          console.info("divTeams");
          console.table(divTeams);

          let divWinner = this.calculateDivWinner(divTeams);
          confWinners.push(divWinner);
        }

        console.info("confWinners");
        console.table(confWinners);

        // Seed the Conference Winners
        confSeeds[conf] = [];

        while (confWinners.length > 1) {
          let winner = this.calculateWCWinner(confWinners);
          confSeeds[conf].push(winner);

          // remove the one we just added
          confWinners = confWinners.filter((team) => {
            return team.name !== winner.name;
          });
        }

        confSeeds[conf].push(confWinners[0]);

        console.info("confSeeds (" + theSeason.conferences[conf] + ")");
        console.table(confSeeds[conf]);

        // determine wild card teams (top 3 in each conference)
        let wcWinners = [];

        // get list of conference teams not including division winners
        let wcTeams = theTeamsWithWins.filter((team) => {
          return (
            team.conference === theSeason.conferences[conf] &&
            confSeeds[conf]
              .map((team) => {
                return team.name;
              })
              .indexOf(team.name) < 0
          );
        });

        console.info("wcTeams (" + theSeason.conferences[conf] + ")");
        console.table(wcTeams);

        while (wcWinners.length < 3) {
          let wildCard = this.calculateWCWinner(wcTeams);
          wcWinners.push(wildCard);
          confSeeds[conf].push(wildCard);

          // remove the one we just added
          wcTeams = wcTeams.filter((team) => {
            return team.name !== wildCard.name;
          });
        }

        // done with this conference
        console.info("confSeeds (" + theSeason.conferences[conf] + ")");
        console.table(confSeeds[conf]);

        this.playoffTeams[conf] = confSeeds[conf];
      }

      console.info("playoffTeams");
      console.table(this.playoffTeams);

      for (let conf = 0; conf < theSeason.conferences.length; conf++) {
        console.info("playoffTeams[" + theSeason.conferences[conf] + "]");
        console.table(this.playoffTeams[conf]);
      }

      // set up the games

      this.wcGames = [];
      let gameId = this.seasonGames + 1;

      for (let conf = 0; conf < theSeason.conferences.length; conf++) {
        // Wildcard Weekend
        // #1 seed has a bye
        // #7 plays at #2
        // #6 plays at #3
        // #5 plays at #4

        let game1 = new Object({
          seasonId: theSeason.seasonId,
          weekNumber: this.seasonWeeks + 1,
          gameId: gameId++,
          visitor: this.playoffTeams[conf][6].name,
          home: this.playoffTeams[conf][1].name,
          winner: null,
        });

        this.wcGames.push(game1);

        let game2 = new Object({
          seasonId: theSeason.seasonId,
          weekNumber: this.seasonWeeks + 1,
          gameId: gameId++,
          visitor: this.playoffTeams[conf][5].name,
          home: this.playoffTeams[conf][2].name,
          winner: null,
        });

        this.wcGames.push(game2);

        let game3 = new Object({
          seasonId: theSeason.seasonId,
          weekNumber: this.seasonWeeks + 1,
          gameId: gameId++,
          visitor: this.playoffTeams[conf][4].name,
          home: this.playoffTeams[conf][3].name,
          winner: null,
        });

        this.wcGames.push(game3);
      }

      // set Wildcard picks to home team (if not set already)

      for (let i = 0; i < this.wcGames.length; i++) {
        let winner =
          this.updatedPicks.picksList[this.wcGames[i].gameId - 1].winner;
        if (
          winner !== this.wcGames[i].home &&
          winner !== this.wcGames[i].visitor
        ) {
          // let pick = {
          //   gameId: this.wcGames[i].gameId,
          //   winner: this.wcGames[i].home,
          // };

          this.updatedPicks.picksList[this.wcGames[i].gameId - 1].winner =
            this.wcGames[i].home;
        }
      }

      console.info("wcGames");
      console.table(this.wcGames);
      console.groupEnd();
    },
    determineDivisionGames() {
      // set up the teams

      let theSeason = this.currentSeason;
      let thePicks = this.updatedPicks.picksList;
      let wcFirstGameId = this.seasonGames + 1;
      let divFirstGameId = wcFirstGameId + 6; // there are 6 wildcard games

      console.group("determineDivisionGames");
      console.info("thePicks");
      console.table(thePicks);

      let wcWinnerNames = [];
      for (let conf = 0; conf < theSeason.conferences.length; conf++) {
        // add the #1 seed to the list of winners (they advance via bye)
        wcWinnerNames.push(this.playoffTeams[conf][0].name);
      }

      for (let i = wcFirstGameId; i < divFirstGameId; i++) {
        wcWinnerNames.push(thePicks[i - 1].winner);
      }

      console.info("wcWinnerNames");
      console.table(wcWinnerNames);

      let wcWinners = [];
      for (let conf = 0; conf < theSeason.conferences.length; conf++) {
        wcWinners[conf] = this.playoffTeams[conf].filter((team) => {
          return wcWinnerNames.indexOf(team.name) >= 0;
        });
        console.info("wcWinners (" + theSeason.conferences[conf] + ")");
        console.table(wcWinners[conf]);
        this.round2Teams[conf] = wcWinners[conf];
      }

      // set up the games

      this.divGames = [];
      let gameId = divFirstGameId;

      for (let conf = 0; conf < theSeason.conferences.length; conf++) {
        // Divisional Playoffs
        // #4 plays at #1
        // #3 plays at #2

        console.info("conf = ", conf);
        let game1 = new Object({
          seasonId: theSeason.seasonId,
          weekNumber: this.seasonWeeks + 2,
          gameId: gameId++,
          visitor: this.round2Teams[conf][3].name,
          home: this.round2Teams[conf][0].name,
          winner: null,
        });

        this.divGames.push(game1);

        let game2 = new Object({
          seasonId: theSeason.seasonId,
          weekNumber: this.seasonWeeks + 2,
          gameId: gameId++,
          visitor: this.round2Teams[conf][2].name,
          home: this.round2Teams[conf][1].name,
          winner: null,
        });

        this.divGames.push(game2);
      }

      // set Division picks to home team (if not set already)

      for (let i = 0; i < this.divGames.length; i++) {
        let winner = thePicks[this.divGames[i].gameId - 1].winner;
        if (
          winner !== this.divGames[i].home &&
          winner !== this.divGames[i].visitor
        ) {
          thePicks[this.divGames[i].gameId - 1].winner = this.divGames[i].home;
        }
      }

      console.info("divGames");
      console.table(this.divGames);
      console.groupEnd();
    },
    determineConferenceGames() {
      // set up the teams

      let theSeason = this.currentSeason;
      let thePicks = this.updatedPicks.picksList;
      let divFirstGameId = this.seasonGames + 7; // there are 6 wildcard games
      let confFirstGameId = divFirstGameId + 4; // there are 4 divisional games

      console.group("determineConferenceGames");
      console.info("thePicks");
      console.table(thePicks);

      let divWinnerNames = [];

      for (let i = divFirstGameId; i < confFirstGameId; i++) {
        divWinnerNames.push(thePicks[i - 1].winner);
      }

      console.info("divWinnerNames");
      console.table(divWinnerNames);

      let divWinners = [];
      for (let conf = 0; conf < theSeason.conferences.length; conf++) {
        divWinners[conf] = this.playoffTeams[conf].filter((team) => {
          return divWinnerNames.indexOf(team.name) >= 0;
        });
        console.info("divWinners (" + theSeason.conferences[conf] + ")");
        console.table(divWinners[conf]);
        this.round3Teams[conf] = divWinners[conf];
      }

      // set up the games

      this.confGames = [];
      let gameId = confFirstGameId;

      for (let conf = 0; conf < theSeason.conferences.length; conf++) {
        // Conference Playoffs
        // #2 plays at #1

        let game1 = new Object({
          seasonId: theSeason.seasonId,
          weekNumber: this.seasonWeeks + 3,
          gameId: gameId++,
          visitor: this.round3Teams[conf][1].name,
          home: this.round3Teams[conf][0].name,
          winner: null,
        });

        this.confGames.push(game1);
      }

      // set Conference picks to home team (if not set already)

      for (let i = 0; i < this.confGames.length; i++) {
        let winner = thePicks[this.confGames[i].gameId - 1].winner;
        if (
          winner !== this.confGames[i].home &&
          winner !== this.confGames[i].visitor
        ) {
          thePicks[this.confGames[i].gameId - 1].winner =
            this.confGames[i].home;
        }
      }

      console.info("confGames");
      console.table(this.confGames);
      console.groupEnd();
    },
    determineSuperBowlGame() {
      // set up the teams

      let theSeason = this.currentSeason;
      let thePicks = this.updatedPicks.picksList;
      let confFirstGameId = this.seasonGames + 11; // there are 6 wildcard games + 4 divisional games (+ 1 since GameId starts at 1, not 0)
      let sbGameId = confFirstGameId + 2; // there are 2 conference games

      let confWinnerNames = [];

      console.group("determineSuperBowlGame");

      for (let i = confFirstGameId; i < sbGameId; i++) {
        confWinnerNames.push(thePicks[i - 1].winner);
      }

      console.info("confWinnerNames");
      console.table(confWinnerNames);

      let confWinners = [];
      for (let conf = 0; conf < theSeason.conferences.length; conf++) {
        confWinners[conf] = this.playoffTeams[conf].filter((team) => {
          return confWinnerNames.indexOf(team.name) >= 0;
        });
        console.info("confWinners (" + theSeason.conferences[conf] + ")");
        console.table(confWinners[conf]);
        this.round4Teams[conf] = confWinners[conf];
      }

      // set up the games

      this.sbGame = [];
      let gameId = sbGameId;

      // The Super Bowl alternates the Home Team between NFC and AFC
      // AFC is the Home team for 2021 / 2022 season
      // Since AFC is theSeason.conferences[0] and to keep the generality of "conferences" length,
      // homeTeam s/b (theSeason.year - 2021) % conferences.length
      // Examples
      //  2021: 2021 - 2021 % 2 = 0
      //  2022: 2022 - 2021 % 2 = 1
      //  2023: 2023 - 2021 % 2 = 0
      //  2024: 2024 - 2021 % 2 = 1
      //  etc.
      //
      //  Of course, more then 2 conferences wouldn't make sense in the current playoff format (Superbowl between 3 or more teams?)

      let homeTeam = (theSeason.year - 2021) % 2;

      let game1 = new Object({
        seasonId: theSeason.seasonId,
        weekNumber: this.seasonWeeks + 4,
        gameId: gameId++,
        visitor: this.round4Teams[(homeTeam + 1) % 2][0].name,
        home: this.round4Teams[homeTeam][0].name,
        winner: null,
      });

      this.sbGame.push(game1);

      // set Conference picks to home team (if not set already)

      for (let i = 0; i < this.sbGame.length; i++) {
        let winner = thePicks[this.sbGame[i].gameId - 1].winner;
        if (
          winner !== this.sbGame[i].home &&
          winner !== this.sbGame[i].visitor
        ) {
          thePicks[this.sbGame[i].gameId - 1].winner = this.sbGame[i].home;
        }
      }

      console.info("sbGame");
      console.table(this.sbGame);
      console.groupEnd();
    },
    createTeamsListWithWins() {
      let teamsList = [];
      const theTeams = this.currentTeamsList;

      console.group("createTeamsListWithWins");
      // Create a new list of all teams (with new objects since we'll be adding the "wins" attribute)

      for (let i = 0; i < theTeams.length; i++) {
        let team = new Object();

        Object.assign(team, theTeams[i]);
        team.wins = 0;

        teamsList.push(team);
      }

      // {
      //   winner: teamId,
      // },

      const totalTeams = theTeams.length;
      const totalGames =
        (totalTeams * this.currentSeason.seasonGamesPerTeam) / 2;

      console.info("totalTeams = ", totalTeams);
      console.info("totalGames = ", totalGames);
      console.info("teamsList");
      console.table(teamsList);
      console.info("picksList");
      console.table(this.updatedPicks.picksList);

      for (let i = 0; i < totalGames; i++) {
        for (let j = 0; j < teamsList.length; j++) {
          if (this.updatedPicks.picksList[i].winner === teamsList[j].name) {
            teamsList[j].wins++;
            break;
          }
        }
      }

      teamsList.sort((a, b) => (a.wins > b.wins ? -1 : 1));

      console.info("resulting sorted list");
      console.table(teamsList);
      console.groupEnd();
      return teamsList;
    },
    calculateDivWinner(teamsListWithWins) {
      console.group("calculateDivWinner");
      console.info("teamsListWithWins");
      console.table(teamsListWithWins);

      let mostWins = teamsListWithWins[0].wins;
      let tiedTeams = teamsListWithWins.filter((team) => {
        return team.wins === mostWins;
      });

      console.info("tiedTeams");
      console.table(tiedTeams);

      if (tiedTeams.length === 1) {
        // only one team with the most wins
        console.groupEnd();
        return tiedTeams[0];
      } else if (tiedTeams.length === 2) {
        // we have a two team tie

        tiedTeams = this.calculateHead2Head(tiedTeams);
        if (tiedTeams.length === 1) {
          console.groupEnd();
          return tiedTeams[0];
        }

        tiedTeams = this.calculateDivision(tiedTeams);
        if (tiedTeams.length === 1) {
          console.groupEnd();
          return tiedTeams[0];
        }

        tiedTeams = this.calculateCommon(tiedTeams);
        if (tiedTeams.length === 1) {
          console.groupEnd();
          return tiedTeams[0];
        }

        tiedTeams = this.calculateConference(tiedTeams);
        if (tiedTeams.length === 1) {
          console.groupEnd();
          return tiedTeams[0];
        }

        // Still tied, next tiebreaker is strength of victory
        // Just pick the first team in the list, so we should always get the same team result

        console.groupEnd();
        return tiedTeams[0];
      } else {
        // we have three or more tied teams

        tiedTeams = this.calculateHead2Head(tiedTeams);
        if (tiedTeams.length === 1) {
          console.groupEnd();
          return tiedTeams[0];
        } else if (tiedTeams.length === 2) {
          //   // Switch to 2-Team Scheme

          console.groupEnd();
          return this.calculateDivWinner(tiedTeams);
        } else {
          // we still have three or more tied teams

          tiedTeams = this.calculateDivision(tiedTeams);
          if (tiedTeams.length === 1) {
            console.groupEnd();
            return tiedTeams[0];
          } else if (tiedTeams.length === 2) {
            // Switch to 2-Team Scheme

            console.groupEnd();
            return this.calculateDivWinner(tiedTeams);
          } else {
            // we still have three or more tied teams

            tiedTeams = this.calculateCommon(tiedTeams);
            if (tiedTeams.length === 1) {
              console.groupEnd();
              return tiedTeams[0];
            } else if (tiedTeams.length === 2) {
              // Switch to 2-Team Scheme

              console.groupEnd();
              return this.calculateDivWinner(tiedTeams);
            } else {
              // we still have three or more tied teams

              tiedTeams = this.calculateConference(tiedTeams);
              if (tiedTeams.length === 1) {
                console.groupEnd();
                return tiedTeams[0];
              } else if (tiedTeams.length === 2) {
                // Switch to 2-Team Scheme

                console.groupEnd();
                return this.calculateDivWinner(tiedTeams);
              } else {
                // we still have three or more tied teams

                // Still tied, next tiebreaker is strength of victory
                // Just pick the first team in the list, so we should always get the same team result
                console.groupEnd();
                return tiedTeams[0];
              }
            }
          }
        }
      }
    },
    calculateHead2Head(teams) {
      const theSchedule = this.currentSchedule;
      // {
      //   seasonId:
      //   weekNumber:
      //   gameId:
      //   home:
      //   visitor:
      //   winner:
      // }

      const picksList = this.updatedPicks.picksList;
      // {
      //   winner: teamId,
      // },

      console.group("calculateHead2Head");
      console.info("teams");
      console.table(teams);

      // get list of Head to Head games
      const h2hgames = theSchedule.filter((game) => {
        for (let i = 0; i < teams.length - 1; i++) {
          if (teams[i].name === game.home || teams[i].name === game.visitor) {
            for (let j = i + 1; j < teams.length; j++) {
              if (
                teams[j].name === game.home ||
                teams[j].name === game.visitor
              ) {
                return true;
              }
            }
          }
        }

        return false;
      });

      console.info("h2hgames");
      console.table(h2hgames);

      const tiedList = this.calculateWins(h2hgames, picksList, teams);

      console.info("tiedList");
      console.table(tiedList);
      console.groupEnd();
      return tiedList;
    },
    calculateWins(gamesList, picksList, teamsList) {
      let i = 0;
      let j = 0;
      let winsList = [];

      for (i = 0; i < teamsList.length; i++) {
        let team = new Object();

        Object.assign(team, teamsList[i]);
        team.wins = 0;

        winsList.push(team);
      }

      console.info("calculateWins: winsList");
      console.table(winsList);

      for (i = 0; i < gamesList.length; i++) {
        let gameWinner = picksList[gamesList[i].gameId - 1].winner;

        for (j = 0; j < winsList.length; j++) {
          if (gameWinner === winsList[j].name) {
            winsList[j].wins++;
          }
        }
      }

      winsList.sort((a, b) => (a.wins > b.wins ? -1 : 1));

      console.info("calculateWins: resulting sorted list");
      console.table(winsList);

      const mostWins = winsList[0].wins;

      console.info("calculateWins: mostWins = ", mostWins);

      const tiesList = winsList.filter((team) => {
        return team.wins === mostWins;
      });

      console.info("calculateWins: resulting ties list (revised wins)");
      console.table(tiesList);

      teamsList = teamsList.filter((team) => {
        return (
          tiesList
            .map((tiedteam) => {
              return tiedteam.name;
            })
            .indexOf(team.name) >= 0
        );
      });

      console.info("calculateWins: resulting teams list (original wins)");
      console.table(teamsList);

      return teamsList;
    },
    calculateDivision(teams) {
      const picksList = this.updatedPicks.picksList;
      // {
      //   winner: teamId,
      // },

      console.info("calculateDivision: teams.length = ", teams.length);
      console.table(teams);

      if (!this.sameDivision(teams)) {
        // if not in the same division, just return the original list (not a tie breaker)
        return teams;
      }

      // in the same division, get all division games
      const divGames = this.getDivisionGames(
        teams[0].conference,
        teams[0].division
      );
      return this.calculateWins(divGames, picksList, teams);
    },
    calculateCommon(teams) {
      const picksList = this.updatedPicks.picksList;
      // {
      //   winner: teamId,
      // },

      console.info("calculateCommon: teams.length = ", teams.length);
      console.table(teams);

      // in the same division, get all division games
      const commonGames = this.getCommonGames(teams);
      return this.calculateWins(commonGames, picksList, teams);
    },
    calculateConference(teams) {
      const picksList = this.updatedPicks.picksList;
      // {
      //   winner: teamId,
      // },

      console.info("calculateConference: teams");
      console.table(teams);

      // in the same division, get all division games
      const conferenceGames = this.getConferenceGames(teams);
      return this.calculateWins(conferenceGames, picksList, teams);
    },
    getDivisionGames(conf, div) {
      const theSchedule = this.currentSchedule;
      const teams = this.currentTeamsList;

      // get list of Division games
      const divGames = theSchedule.filter((game) => {
        for (let i = 0; i < teams.length - 1; i++) {
          if (
            (teams[i].name === game.home || teams[i].name === game.visitor) &&
            teams[i].conference === conf &&
            teams[i].division === div
          ) {
            for (let j = i + 1; j < teams.length; j++) {
              if (
                (teams[j].name === game.home ||
                  teams[j].name === game.visitor) &&
                teams[j].conference === conf &&
                teams[j].division === div
              ) {
                // both teams are in the division
                return true;
              }
            }
          }
        }
      });

      console.info("getDivisionGames: divGames.length = ", divGames.length);
      console.table(divGames);
      return divGames;
    },
    getCommonGames(teams) {
      const theSchedule = this.currentSchedule;
      let commonOpponents = [];
      let myOpponents = [];
      let commonGames = [];
      let teamNames = [];

      // create list of team names from teams array
      for (let i = 0; i < teams.length; i++) {
        teamNames.push(teams[i].name);
      }

      // get list of all opponents of first team
      let theTeam = teamNames[0];
      commonGames = theSchedule.filter((game) => {
        return game.home === theTeam || game.visitor === theTeam;
      });
      for (let i = 0; i < commonGames.length; i++) {
        commonOpponents.push(
          commonGames[i].home === theTeam
            ? commonGames[i].visitor
            : commonGames[i].home
        );
      }

      console.info(
        "getCommonGames: commonOpponents.length = ",
        commonOpponents.length
      );
      console.table(commonOpponents);

      // de-dupe the array
      commonOpponents = [...new Set(commonOpponents)];
      console.info(
        "getCommonGames: commonOpponents (de-duped).length = ",
        commonOpponents.length
      );
      console.table(commonOpponents);

      // for remaining teams, filter initial list by their opponents
      for (let i = 1; i < teams.length; i++) {
        theTeam = teams[i].name;
        commonGames = theSchedule.filter((game) => {
          return game.home === theTeam || game.visitor === theTeam;
        });
        for (let j = 0; j < commonGames.length; j++) {
          myOpponents.push(
            commonGames[i].home === theTeam ? commonGames[i].visitor : theTeam
          );
        }

        // remove any opponent from commonOpponents who are not also in myOpponents
        commonOpponents = commonOpponents.filter((team) => {
          return myOpponents.indexOf(team) < 0;
        });
        console.info(
          "getCommonGames: commonOpponents (pare down " + i + ").length = ",
          commonOpponents.length
        );
        console.table(commonOpponents);
      }

      // result is common opponents for all teams
      // filter all games for home in teams and visitor in commonOpponents or vice versa
      commonGames = theSchedule.filter((game) => {
        return (
          (commonOpponents.indexOf(game.home) >= 0 &&
            teamNames.indexOf(game.visitor) >= 0) ||
          (commonOpponents.indexOf(game.visitor) >= 0 &&
            teamNames.indexOf(game.home) >= 0)
        );
      });

      console.info(
        "getCommonGames: final commonGames.length = ",
        commonGames.length
      );
      console.table(commonGames);
      return commonGames;
    },
    getConferenceGames(teams) {
      const theSchedule = this.currentSchedule;
      const theTeams = this.currentTeamsList;
      let conference = teams[0].conference;

      console.info("getConferenceGames: teams");
      console.table(teams);

      // Get array of conference Teams
      let conferenceTeams = theTeams.filter((team) => {
        return team.conference === conference;
      });

      console.info("getConferenceGames: (all) conferenceTeams");
      console.table(conferenceTeams);

      // Get array of games between two conference Teams
      let conferenceGames = theSchedule.filter((game) => {
        return (
          conferenceTeams
            .map((team) => {
              return team.name;
            })
            .indexOf(game.home) >= 0 &&
          conferenceTeams
            .map((team) => {
              return team.name;
            })
            .indexOf(game.home) >= 0
        );
      });

      console.info("getConferenceGames: (all) conferenceGames");
      console.table(conferenceGames);

      // Remove games that don't include a team in 'teams'
      conferenceGames = conferenceGames.filter((game) => {
        return (
          teams
            .map((team) => {
              return team.name;
            })
            .indexOf(game.home) >= 0 ||
          teams
            .map((team) => {
              return team.name;
            })
            .indexOf(game.visitor) >= 0
        );
      });

      console.info("getConferenceGames: (teams-only) conferenceGames)");
      console.table(conferenceGames);

      return conferenceGames;
    },
    sameDivision(teams) {
      // get the conference and division for the first team
      let conf = teams[0].conference;
      let div = teams[0].division;

      // start at 1 since we already know the first team's division
      for (let i = 1; i < teams.length; i++) {
        if (teams[i].conference !== conf || teams[i].division !== div) {
          return false;
        }
      }

      return true;
    },
    calculateWCWinner(teams) {
      console.info("calculateWCWinner: teams");
      console.table(teams);

      // Calculate the #1 team in the list

      // Don't assume team with most wins is first in the list
      let mostWins = teams[0].wins;
      for (let i = 1; i < teams.length; i++) {
        if (teams[i].wins > mostWins) {
          mostWins = teams[i].wins;
        }
      }

      let tiedTeams = teams.filter((team) => {
        return team.wins === mostWins;
      });

      console.info("calculateWCWinner: tiedTeams");
      console.table(tiedTeams);

      if (tiedTeams.length === 1) {
        // only one team with the most wins
        return tiedTeams[0];
      } else if (tiedTeams.length === 2) {
        tiedTeams = this.calculateHead2Head(tiedTeams);
        if (tiedTeams.length === 1) {
          return tiedTeams[0];
        }

        tiedTeams = this.calculateDivision(tiedTeams);
        if (tiedTeams.length === 1) {
          return tiedTeams[0];
        }

        tiedTeams = this.calculateCommon(tiedTeams);
        if (tiedTeams.length === 1) {
          return tiedTeams[0];
        }

        tiedTeams = this.calculateConference(tiedTeams);
        if (tiedTeams.length === 1) {
          return tiedTeams[0];
        }

        // Still tied, next tiebreaker is strength of victory
        // Just pick the first team in the list, so we should always get the same team result

        return tiedTeams[0];
      } else {
        // we have three or more tied teams

        tiedTeams = this.calculateHead2Head(tiedTeams);
        if (tiedTeams.length === 1) {
          return tiedTeams[0];
        } else if (tiedTeams.length === 2) {
          //   // Switch to 2-Team Scheme

          return this.calculateDivWinner(tiedTeams);
        } else {
          // we still have three or more tied teams

          tiedTeams = this.calculateDivision(tiedTeams);
          if (tiedTeams.length === 1) {
            return tiedTeams[0];
          } else if (tiedTeams.length === 2) {
            // Switch to 2-Team Scheme

            return this.calculateWCWinner(tiedTeams);
          } else {
            // we still have three or more tied teams

            tiedTeams = this.calculateCommon(tiedTeams);
            if (tiedTeams.length === 1) {
              return tiedTeams[0];
            } else if (tiedTeams.length === 2) {
              // Switch to 2-Team Scheme

              return this.calculateWCWinner(tiedTeams);
            } else {
              // we still have three or more tied teams

              tiedTeams = this.calculateConference(tiedTeams);
              if (tiedTeams.length === 1) {
                return tiedTeams[0];
              } else if (tiedTeams.length === 2) {
                // Switch to 2-Team Scheme

                return this.calculateWCWinner(tiedTeams);
              } else {
                // we still have three or more tied teams

                // Still tied, next tiebreaker is strength of victory
                // Just pick the first team in the list, so we should always get the same team result
                return tiedTeams[0];
              }
            }
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.picks--complete {
  font-size: small;
  padding-top: 0;
}

.nickname {
  width: 60%;
}

.list--weeks {
  list-style-type: none;
  padding: 0;
  max-width: 95%;
}

.list--weeks li {
  margin: 0.5rem 0;
}

.filter--team {
  float: right;
  margin-right: 2rem;
  min-width: 10ch;
}

.div--visitor {
  display: inline-block;
  color: orange;
  justify-content: left;
  width: 50%;
}

.div--home {
  display: inline-block;
  color: green;
  justify-content: right;
  width: 50%;
}

.buttons--list {
  float: right;
}

.button--first {
  /* position: relative;
  right: 0rem;
  bottom: 0; */
  /* margin-left: 59%; */
  margin-right: 10px;
  min-width: 10ch;
  visibility: hidden;
}

.button--prev {
  /* margin-left: 59%; */
  /* margin-right: 10px; */
  /* margin-right: 2rem; */
  min-width: 10ch;
}

.button--next {
  /* position: relative;
  right: 0;
  bottom: 0; */
  /* margin-left: 0; */
  min-width: 25ch;
}

.team-seed {
  column-count: 3;
  box-sizing: border-box;
  border: solid #033111 2px;
  /* border-bottom: none; */
}

.seed {
  width: 30%;
  text-align: center;
}

.team {
  width: auto;
}

.wl {
  width: 40%;
  text-align: center;
}

.header {
  text-align: center;
}

.div--winner {
  display: inline-block;
  color: green;
  vertical-align: middle;
  width: 50%;
}

.div--loser {
  display: inline-block;
  color: red;
  text-decoration: line-through;
  vertical-align: middle;
  width: 50%;
}

.div--weeks ul {
  margin-left: auto;
  margin-right: auto;
}

.div--weeks div {
  margin-left: auto;
  margin-right: auto;
}
</style>